export default "__VITE_ASSET__DeijAkFH__"